'use strict'

import React from 'react';

import {DeleteItem} from '../components/AreaForm.jsx';
import FormattedContent from '../components/FormattedContent.jsx';

import Translations from '../../app/utils/translations.js';
let translations=new Translations([
  require('./labels/english.js'),
  require('./labels/norwegian.js')
]);

let actionTranslations=new Translations([
  require('../components/labels/english.js'),
  require('../components/labels/norwegian.js')
]);

export class LessonStatement extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).general.statement;
    let lesson=this.props.lesson
    return (
      <div style={{fontStyle:"italic"}}>
        <span style={{fontStyle:"normal"}}>"{lesson.effect}"</span>
        <span> </span>
        ({labels.effect})
        <span> </span>
        {labels.because}
        <span> </span>
        <span style={{fontStyle:"normal"}}>"{lesson.event}"</span>
        <span> </span>
        ({labels.event})
        <span>. </span>
        <span>{labels.thisWasCausedBy}</span>
        <span> </span>
        <span style={{fontStyle:"normal"}}>"{lesson.cause}"</span>
        <span> </span>
        ({labels.cause})
      </div>
    );
  }
}

class LessonActions extends React.Component {

  render() {
    let labels=actionTranslations.getTranslation(this.props).form;
    let buttonLabels=translations.getTranslation(this.props).general.lessons.actions;
    let deleteLabel=translations.getTranslation(this.props).general.lesson;
    let lesson=this.props.lesson;
    let fromThisProject=this.props.project!==undefined && lesson.source!==undefined && this.props.project.id===lesson.source.id;
    let hasAppliedLesson=this.props.project!==undefined && lesson.applied!==undefined && lesson.applied.filter(appliedBy=>appliedBy.id===this.props.project.id).length>0;
    let deleteEnabled=fromThisProject;
    let editEnabled=fromThisProject;
    let applyEnabled=!fromThisProject && !hasAppliedLesson;
    let unapplyEnabled=!fromThisProject && hasAppliedLesson;
    return (
      <div style={{paddingTop:30}}>
        <div style={{display:"flex", width:"100%", justifyContent: "space-between"}}>
          <input className="cancel" type="button" onClick={this.props.onCancel} name="cancel" value={labels.cancel}/>
          {deleteEnabled ? (
            <DeleteItem {...this.props} label={deleteLabel} confirmDeleteMessage={buttonLabels.confirmDelete}
              onConfirm={this.props.onDelete}/>
          ) : null}
          {applyEnabled ? (
            <input onClick={this.props.onApply} className="save" type="submit" name="save" value={buttonLabels.applyLesson}/>
          ) : unapplyEnabled ? (
            <input onClick={this.props.onUnapply} className="save" type="submit" name="save" value={buttonLabels.unapplyLesson}/>
          ) : editEnabled ? (
            <input onClick={this.props.onEdit} className="save" type="submit" name="save" value={buttonLabels.editLesson}/>
          ) : null}
        </div>
      </div>
    );
  }
}

export default class LessonDetails extends React.Component {
  render() {
    let title=translations.getTranslation(this.props).general.lesson;
    let labels=translations.getTranslation(this.props);
    let lesson=this.props.lesson;
    return (
      <div>
        <h2>{lesson.title}</h2>
        <LessonStatement {...this.props}/>
        {lesson.description!==undefined && lesson.description.trim().length>0 ? (
          <div style={{paddingTop:15}}>
            <FormattedContent value={lesson.description}/>
          </div>
        ) : null}
        <div style={{paddingTop:15}}>
          <div>
            <b>{labels.followUp.fields.indicators.title}</b>
          </div>
          <div style={{paddingLeft:10}}>
            <FormattedContent value={lesson.indicators}/>
          </div>  
        </div>
        <div style={{paddingTop:15}}>
          <div>
            <b>{labels.followUp.fields.recommendations.title}</b>
          </div>
          <div style={{paddingLeft:10}}>
            <FormattedContent value={lesson.recommendations}/>
          </div>
        </div>
        <div style={{paddingTop:15}}>
          <div>
            <b>{labels.summary.fields.type.title}</b>
          </div>
          {labels.summary.fields.type.options[lesson.type]}
        </div>
        <div style={{paddingTop:15}}>
          <div>
            <b>{labels.summary.fields.priority.title}</b>
          </div>
          {labels.summary.fields.priority.options[lesson.priority]}
        </div>
        {lesson.source!==undefined && lesson.source.id!==undefined ? (
          <div style={{paddingTop:15}}>
            <div>
              <b>{labels.general.lessons.source}</b>
            </div>
            <a href={"/projects/"+lesson.source.id+"/"}>{lesson.source.name}</a>
          </div>
        ) : null}
        {lesson.applied!==undefined ? (
          <div style={{paddingTop:15}}>
            <div>
              <b>{labels.general.lessons.appliedIn}</b>
            </div>
            <ul style={{marginTop: 0}}>
              {lesson.applied.map(project=>(
                <li key={project.id}><a href={"/projects/"+project.id+"/"}>{project.name}</a></li>
              ))}
            </ul>
          </div>
        ) : null}
        <LessonActions {...this.props}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./views/plan/LessonDetails.jsx